export default "__VITE_ASSET__ImY98gg4__"